import { IListOption } from "src/store/models/listOption.models";

export function keyValueToDropdownOption(kvp: IListOption) {
  return {
    label: kvp.key,
    value: kvp.value,
  };
}

export function mapKeyToValue(key: string | null, list: { key: string; value: number }[]) {
  if (!key) return null;
  const found = list?.find(option => option.key === key);
  return found?.value ?? null;
}

export function mapValueToKey(value: number | null, list: { key: string; value: number }[]) {
  const found = list?.find(option => option.value === value);
  return found?.key ?? null;
}
